import { ErrorMessage } from "components/shared/ErrorMessage";
import { RespondToLicensingSignInChallengeError } from "generatedQueries/respondToNewPasswordRequiredChallengeMutation.graphql";
import React, { FC } from "react";
import { MessageDescriptor } from "react-intl";
import { WarningMessage } from "shared/components/WarningMessage";
import { mapMessages } from "shared/mapMessages";
import { messages as passwordStrengthMessages } from "shared/validations/validations";

export const messages = mapMessages("components.user.login", {
    unhandledChallengeErrorMessage: "An unhandled error occurred while setting up your account, please try again later.",
});

interface IProps {
    error: boolean | RespondToLicensingSignInChallengeError;
    passwordStrengthError: MessageDescriptor | string | undefined;
}

export const ChallengeError: FC<IProps> = ({
    error,
    passwordStrengthError,
}) => <>
        {
            error === "NEWPASSWORDINVALID" &&
            <WarningMessage message={passwordStrengthError ?? passwordStrengthMessages.defaultPasswordStrengthError} />
        }
        {
            error === true &&
            <ErrorMessage message={messages.unhandledChallengeErrorMessage} />
        }
    </>;
